import React, { useState } from 'react';
import { CONSTANTS } from '../../constants';

function Plans(props) {
  const { plans, onSubmit, isLoading, selectedPlan, setSelectedPlan } = props;
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handlePlanChange = (plan) => {
    setAcceptedTerms(false);
    setSelectedPlan(plan);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="halan_form">
      <div className="halan_form_content">
        <label className="halan_input_label">{CONSTANTS.PLANS.TITLE}</label>
        <div className="halan_plans">
          {plans &&
            plans.map((plan) => (
              <label key={plan.id} className="halan_plan">
                <input
                  defaultChecked={selectedPlan && selectedPlan.id === plan.id}
                  onChange={() => handlePlanChange(plan)}
                  value={plan.id}
                  type="radio"
                  name="plan"
                  id={plan.id}
                />
                <div className="halan_plan-content">
                  <div className="halan_plan-details">
                    <span>
                      {CONSTANTS.PLANS.CURRENCY} {plan.amount} /{' '}
                      {CONSTANTS.PLANS.MONTH}
                    </span>
                    <p>
                      {plan.months} {CONSTANTS.PLANS.MONTHS.toLowerCase()}
                    </p>
                  </div>
                </div>
              </label>
            ))}
        </div>
        {selectedPlan && !!selectedPlan.adminFees && (
          <div className="halan_checkbox_container">
            <input
              type="checkbox"
              id="adminFees"
              name="adminFees"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <label for="adminFees">
              I agree to pay{' '}
              {selectedPlan.adminFees.toLocaleString('en-US', {
                minimumFractionDigits: 2,
              })}{' '}
              EGP in cash for admin fees upon delivery
            </label>
          </div>
        )}
      </div>
      <button
        onClick={handleSubmit}
        disabled={
          !selectedPlan ||
          (selectedPlan && selectedPlan.adminFees && !acceptedTerms) ||
          isLoading
        }
        className={`halan_btn halan_btn_main ${
          isLoading ? 'halan_btn_loading' : ''
        }`}
      >
        {!isLoading && CONSTANTS.PLANS.BTN}
        {isLoading && <div className="halan_loader" />}
      </button>
    </form>
  );
}

export default Plans;
